<template>
  <el-col :span="24">

    <el-col :span="20" style="text-align: right;margin-top: 20px;margin-bottom: 20px;">
      <ComponentDatePicker ref="ComponentDatePicker"></ComponentDatePicker>
    </el-col>
    <el-col :span="4" style="text-align: center;margin-top: 20px;margin-bottom: 20px;">
   <el-button type="danger" @click="ostentation_time">按时间查询排场</el-button>
    <!--  <el-button type="danger" @click="daochu">导出</el-button> -->
    </el-col>
    <el-table :data="
      tableData.filter(
        (data) =>
          !search || data.name.toLowerCase().includes(search.toLowerCase())
      )
    "  border
     height="735px"
     highlight-current-row
     style="width: 100%">
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column align="left" label="排场操作"  width="250">
        <template slot-scope="scope">
          核销时间:{{scope.row.verify_time}} <br>
          预定开始时间:{{scope.row.order_type==1?scope.row.start_time:""}} <br>
          预定结束时间:{{scope.row.order_type==1?scope.row.end_time:""}}
        </template>
      </el-table-column>
      <el-table-column label="手机号" prop="phone" width="150" ></el-table-column>
      <el-table-column label="人数" width="50" align="center" prop="people_count"> </el-table-column>
      <el-table-column label="游戏名称" prop="game_id" width="100">
        <template slot-scope="scope">
          {{game_name(scope.row.game_id).name}}
        </template>
      </el-table-column>

      <el-table-column label="用户来源"  prop="people_source" width="80">
        <template slot-scope="scope">
          {{user_source.find(item => item.value==scope.row.people_source).label}}
        </template>
      </el-table-column>

      <el-table-column label="订单金额"  prop="pay_price" width="80">
        <template slot-scope="scope">
        {{scope.row.pay_price}}
        </template>
      </el-table-column>

      <el-table-column label="详细支付"  prop="pay_source" width="300">
        <template slot-scope="scope">
          <div v-for="item in JSON.parse(scope.row.pay_source)" :key="item.id">
            {{item.title}}: {{item.card_money}}
             <br>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="订单号"  prop="order_sn" width="200">
        <template slot-scope="scope">
          {{scope.row.order_sn}}
        </template>
      </el-table-column>
      <el-table-column label="加入场次次数"  prop="ostentation_status" width="80">
        <template slot-scope="scope">
          {{scope.row.ostentation_status}}
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="remark" width="220">
        <template slot-scope="scope">
          {{scope.row.remark}}
        </template>
      </el-table-column>
      <el-table-column label="操作" prop="ostentation_status" width="200" >
        <template slot-scope="scope">
          <div v-show="scope.row.ostentation_status==0">
            <el-button  type="primary" size="mini"  @click="creat(scope.row.id,scope.row.game_id)" >新建排场</el-button>
            <el-button  type="primary" size="mini" @click="add(scope.row.id)" >加入排场</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="paichang_title" :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="dialogFormVisible_paichang" width="30%">
      <el-form  :model="form"  :label-width="formLabelWidth">
        <el-form-item label="时间:">
          <el-date-picker
                v-model="value1"
                type="datetime"
                placeholder="选择时间"
                 value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm"
                 :picker-options="pickerOptions1"
                >
              </el-date-picker>
        </el-form-item>
        <el-form-item label="厅位:">
          <el-select style="width: 100%;"  v-model="hall_value" placeholder="请选择">
            <el-option v-for="item in hall_list" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="游戏名称:">
          <el-select style="width: 100%;"  v-model="shop_game_value" :disabled="this.dialogFormVisible_paichang_start" placeholder="请选择">
            <el-option v-for="item in shop_game" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="陪玩人数:">
          <el-select style="width: 100%;"  v-model="Playwith_value" placeholder="请选择">
            <el-option v-for="item in Playwith" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="游戏时长:">
          <el-select style="width: 100%;"  v-model="time_value" placeholder="请选择">
            <el-option v-for="item in time_type" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="付费状态:">
          <el-checkbox v-model="aftert_pay_status" disabled=1 >后付费</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cannelStartGame">取 消</el-button>
        <el-button type="primary" @click="AddOstentation">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="可以加入场次" :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="dialogFormVisible_addpaichang" width="40%">
      <el-table :data="
        tableDataCanAddPaiChang.filter(
          (data) =>
            !search || data.name.toLowerCase().includes(search.toLowerCase())
        )
      "  border
       style="width: 100%">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column align="left" label="排场信息"  width="250">
          <template slot-scope="scope">
             {{game_name(scope.row.game_id).name}}<br>
             {{ret_YearMonthDate(scope.row.time_start)}}<br>
             {{ret_YearMonthDateHoursMin(scope.row.time_start)}} ~ {{ret_YearMonthDateHoursMin(scope.row.time_end)}}<br>
             {{scope.row.hall_type}}厅<br>
             陪玩{{scope.row.play_with_count}}人<br>
             {{scope.row.aftert_pay_status==1?"后付费":"先付费"}}<br>
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="">
          <template slot-scope="scope">
              <el-button  type="primary" size="medium"  @click="add_paichang(scope.row.id,scope.row.hall_type)" >加入</el-button>
          </template>
        </el-table-column>
      </el-table>

    </el-dialog>
  </el-col>

</template>

<script>
  import {
    //小程序订单获取要加入的排场
    protocol_ZgrMiniprogramOrders_ostentation,
    //小程序订单加入排场
    protocol_ZgrMiniprogramOrders_miniProgramOrder_add,
    //小程序订单新建排场
    protocol_ZgrMiniprogramOrders_add,
    //获取待排场的记录
    protocol_ZgrShopOstentation_PaiChangWaiting
  } from '@/assets/js/network/request';
  import {
    gUtilityTime
  } from '@/assets/js/utility/UtiltiyTime';
  import {
      gUtilityExcel
    } from "@/assets/js/utility/UtilityExcel";
  import payment_methodagent from "@/assets/js/payment_methodagent.json";
  import ComponentDatePicker from "@/components/ComponentDatePicker";
  import {
    gAccount
  } from '@/assets/js/data/Account'
  import {
    gGameData
  } from '@/assets/js/data/GameData'
  export default {
    components: {
      ComponentDatePicker
    },
    data() {
      return {
        drawer: false,
        //可以加入排场控制
        dialogFormVisible_addpaichang:false,

        pickerOptions1: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          },
        },
        hall_value:1,
        shop_game:[],
        value1: '',
        formLabelWidth: '120px',
        paichang_title:"添加排场",
        dialogFormVisible_paichang:false,
        aftert_pay_status:false,
        form: {
          name: '',
          phone:"",
          turnover:0,
          paid_amount:0,
          volume_code:'',
          waiter:'',
          desc:"",
          payment_serial_number:""
        },
        //待排场小程序订单
        tableData: [],
        //可以加入的排场
        tableDataCanAddPaiChang:[],
        Playwith_value:0,
        search: '',
        shop_game_value:'',
        Playwith:[
          {
            value: 0,
            label: '0'
          },{
            value: 1,
            label: '1'
          }
          ],
        time_value:20,
        time_type:[
          {
            value: 20,
            label: '20分钟'
          },{
            value: 30,
            label: '30分钟'
          },{
            value: 40,
            label: '40分钟'
          },{
            value: 50,
            label: '50分钟'
          },{
            value: 60,
            label: '60分钟'
          }
        ],
        hall_list:[{
            value: '1',
            label: '1'
          }, {
            value: '2',
            label: '2'
        }],
        shop_game_value:'',
        user_source:[{
          value: 1,
          label: '线下路过',
        }, {
          value: 2,
          label: '电话预定'
        }, {
          value: 3,
          label: '业务招待'
        }, {
          value: 4,
          label: '线上预订-大众点评/美团'
        }, {
          value: 5,
          label: '线上团购-大众点评/美团'
        }, {
          value: 6,
          label: '线上预订-口碑团购'
        }, {
          value: 7,
          label: '线上预订-b站'
        }, {
          value: 8,
          label: '线上预订-猫眼'
        }, {
          value: 9,
          label: '线上预订-抖音'
        },{
          value: 10,
          label: '微盟'
        },{
          value: 11,
          label: '其他'
        },{
          value: 12,
          label: '私域'
        },{
          value: 13,
          label: '小程序'
        }],
        payment_method_agent:[],
        dialogFormVisible_paichang_start:false,
      }
    },
    methods: {
      handleClose(done) {
      done();
      },
      game_name(id){
        return  gGameData.getDataByID(id)
      },
      creat(id,game_id){

        // if(this.tableData.length!=0){
        //   if(this.currentRow!="" && this.currentRow!=null){
        //     this.value1 = new Date(this.currentRow.time_end*1000+1000*60*1);
        //   }else{
        //     this.value1 =new Date(this.tableData[this.tableData.length-1].time_end*1000+1000+1000*60*1)
        //   }
        // }else{
      this.value1 =new Date()
        // }
      this.miniprogramOrderId=id;
      this.dialogFormVisible_paichang=true;
      this.shop_game_value=this.game_name(game_id).name;
      },
      //添加场次
      AddOstentation(){
        var _this = this;
        if(this.shop_game_value==''){
          this.$message({
            message: '请选择游戏',
            type: 'warning'
          });
          return
        }
        if(this.value1==null || this.value1==''){
          this.$message({
            message: '请选择时间',
            type: 'warning'
          });
          return
        }
        _this.open_wait_for(1);
          protocol_ZgrMiniprogramOrders_add(
          _this.hall_value,
          (new Date(this.value1).getTime())/1000,
          ((new Date(this.value1).getTime())+(this.time_value*60*1000))/1000,
          gGameData.getDataByName(this.shop_game_value).id,
          this.Playwith_value,
           _this.aftert_pay_status==true?1:0,
           _this.miniprogramOrderId
          ).then(res=>{
            _this.open_wait_for(2);
            if(res.code==0){
              _this.$message({
                message: '添加成功',
                type: 'success'
              });
              for (let i = 0; i < _this.tableData.length; i++) {
                 if(_this.tableData[i].id == _this.miniprogramOrderId)
                 {
                   _this.tableData[i].ostentation_status+=1;
                 }
              }
              _this.cannelStartGame();
            }
          })
      },

      //关闭弹窗
      cannelStartGame() {
        this.dialogFormVisible_paichang = false;
        this.shop_game_value='';
        this.miniprogramOrderId=0;
      },
      //加入排场选择页面
      add(id){
        this.dialogFormVisible_addpaichang=true;
        this.miniprogramOrderId=id;
        let _this=this;
         _this.tableDataCanAddPaiChang=[];
      // let date=new Date();
      // if(time_start==undefined){
      //   time_start=gUtilityTime.YesterDay((date.getTime()) - (1000*60*60*24),1);
      //   time_end=gUtilityTime.YesterDay((date.getTime()) - (1000*60*60*24),2);
      // }
        protocol_ZgrMiniprogramOrders_ostentation().then(res=>{
        _this.tableDataCanAddPaiChang=res.ret;
        console.log(res.ret);
        })
      },
      //加入排场方法
      add_paichang(ostentation_order_id,hall_type){

       var _this = this;

        _this.open_wait_for(1);
          protocol_ZgrMiniprogramOrders_miniProgramOrder_add(
          hall_type,
          _this.miniprogramOrderId,
          ostentation_order_id
          ).then(res=>{
            _this.open_wait_for(2);
            if(res.code==0){
              _this.$message({
                message: '添加成功',
                type: 'success'
              });
              for (let i = 0; i < _this.tableData.length; i++) {
                 if(_this.tableData[i].id == _this.miniprogramOrderId)
                 {
                   _this.tableData[i].ostentation_status+=1;
                 }
              }
              _this.canneladd_paichang();
            }
          })
      },

      canneladd_paichang(){
        this.dialogFormVisible_addpaichang=false;
        this.miniprogramOrderId=0;
      },
      game_name(id){
        return gGameData.getDataByIDFromAllGameData(id)
      },
      ret_YearMonthDate(time){
        return gUtilityTime.YearMonthDate(time,1)+gUtilityTime.YearMonthDate(time,2)+gUtilityTime.YearMonthDate(time,3)
      },
      ret_YearMonthDateHoursMin(time){
        return gUtilityTime.YearMonthDate(time,4)+gUtilityTime.YearMonthDate(time,5)
      },
      ostentation_time(){
        this.init(gUtilityTime.startTime(this.$refs.ComponentDatePicker.get_time_start())/1000,gUtilityTime.endTime(this.$refs.ComponentDatePicker.get_time_end())/1000)
      },
      init(time_start,time_end) {
        let _this=this;
         _this.tableData=[];
        let date=new Date();
        if(time_start==undefined){
          time_start=gUtilityTime.YesterDayday((date.getTime()) - (1000*60*60*24),1);
          time_end=gUtilityTime.YesterDayday((date.getTime()) - (1000*60*60*24),2);
        }
        protocol_ZgrShopOstentation_PaiChangWaiting(time_start,time_end).then(res=>{
          _this.tableData=res.ret;
          console.log(res.ret);
        })
      },
      //打开全局等待框
      open_wait_for(type){
        if(type==1){
          let loading = this.$loading({
                  lock: true,
                  text: '请求中，请耐心等待',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)',
           });
           this.loading=loading;
        }else{
          this.loading.close();
        }
      },
    },
    mounted() {
      this.payment_method_agent = payment_methodagent;
      this.init();
      this.shop_game = gGameData.getAllDataShopDataPrice();
    },
    //监控时间单选
      watch:{
        'shop_game_value':function(newVal,oldVal){
          for(let i=0;i<this.shop_game.length;i++){
            if(this.shop_game[i].name==newVal){
              this.time_value=this.game_name(this.shop_game[i].id).duration
            }
          }
        },
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/PaiChangWaiting.vue